import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Checkbox,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Grid,
    TextareaAutosize,
    Button
} from '@material-ui/core';
import { leadFormStyles } from './styles';
import TinyMce from '../../collums-components/components/common/TinyMce/TinyMce';
import OpenedModal from '../common/OpenedModal';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { modalsButtonStyles } from '../../collums-constants/styles/stylesheets/buttonsStyles';
import SettingsApi from '../../api/SettingsApi';
import { toastr } from 'react-redux-toastr';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function LeadForm() {
    const globalStyles = makeStyles(modalsButtonStyles)();
    const classes = makeStyles(leadFormStyles)();
    const editorRef = useRef();
    const [formTitle, setFormTitle] = useState('Submit an enquiry');
    const [base64, setBase64] = useState('');
    const [interestedIn, setInterestedIn] = useState(
        'Injectables\n' + 'Laser hair removal\n' + 'HydraFacial\n' + 'Peels\n' + 'Microneedling\n' + 'Skin health' // eslint-disable-line
    );
    const [footerText, setFooterText] = useState(
        '<p>We may contact you from time to time about our services, you can opt out at any time.<br/>' +
            'Please see our T&Cs here</p>'
    );
    const [thankYouText, setThankYouText] = useState(
        '<p>Thank you for your enquiry,<br/>we&apos;ll be in touch as soon as we can</p>'
    );
    const [selectedFont, setSelectedFont] = useState('Arial');

    const [marketingText, setMarketingText] = useState('How do you give us permission to contact you?');
    const [redirectUrl, setRedirectUrl] = useState('');
    const [fields, setFields] = useState([
        { label: 'Title', name: 'title', show: false, required: false },
        { label: 'First name', name: 'firstName', show: true, required: true, disabled: true },
        { label: 'Last name', name: 'surname', show: true, required: true, disabled: true },
        { label: 'Dob', name: 'dateOfBirth', show: false, required: false },
        { label: 'Email', name: 'email', show: true, required: true, disabled: true },
        { label: 'Mobile', name: 'mobilePhone', show: false, required: false },
        { label: 'Gender', name: 'gender', show: false, required: false },
        { label: 'Referral source', name: 'referralSource', show: false, required: false }
    ]);
    const [colors, setColors] = useState({
        background: '#ffffff',
        text: '#000000',
        button: '#007bff',
        buttonText: '#ffffff'
    });
    const [interestedTitle, setInterestedTitle] = useState('Treatments interested in');
    const [messageTitle, setMessageTitle] = useState('Leave us a message');
    const [showInterestedIn, setShowInterestedIn] = useState(true);
    const [showMessageField, setShowMessageField] = useState(false);

    const fonts = [
        'Abril Fatface',
        'Albert Sans',
        'Alegreya',
        'Aleo',
        'Anton',
        'Arapey',
        'Archivo',
        'Arial',
        'Arimo',
        'Arvo',
        'Asap',
        'Asap Condensed',
        'Assistant',
        'Baloo 2',
        'Barlow',
        'Be Vietnam Pro',
        'Bebas Neue',
        'Besley',
        'Bitter',
        'Brawler',
        'Cabin',
        'Caladea',
        'Cambay',
        'Cardo',
        'Carme',
        'Caveat',
        'Chivo',
        'Cinzel',
        'Cormorant',
        'Crimson Text',
        'Dancing Script',
        'David Libre',
        'DM Sans',
        'Domine',
        'EB Garamond',
        'Encode Sans Semi Condensed',
        'Enriqueta',
        'Fanwood Text',
        'Fira Code',
        'Fira Sans',
        'Frank Ruhl Libre',
        'Fraunces',
        'Gambetta',
        'Gelasio',
        'Great Vibes',
        'Halant',
        'Headland One',
        'Inconsolata',
        'Indie Flower',
        'Inter',
        'Italianno',
        'JetBrains Mono',
        'Josefin Sans',
        'Karla',
        'Lato',
        'Ledger',
        'Libre Baskerville',
        'Libre Franklin',
        'Lobster',
        'Lora',
        'Lustria',
        'Maitree',
        'Manrope',
        'Merriweather',
        'Montserrat',
        'Muli',
        'Nanum Gothic',
        'Nixie One',
        'Noto Sans',
        'Noto Serif',
        'Nunito',
        'Open Sans',
        'Oswald',
        'Overpass Mono',
        'Oxygen',
        'Pacifico',
        'Passion One',
        'Philosopher',
        'Playfair Display',
        'Poppins',
        'PT Sans',
        'PT Serif',
        'Quattrocento',
        'Quattrocento Sans',
        'Quicksand',
        'Radley',
        'Raleway',
        'Rasa',
        'Recia',
        'Righteous',
        'Roboto',
        'Roboto Condensed',
        'Rokkitt',
        'Rubik',
        'Slabo 27px',
        'Sora',
        'Source Code Pro',
        'Source Sans 3',
        'Source Serif 4',
        'Space Grotesk',
        'Space Mono',
        'Spectral',
        'Stint Ultra Expanded',
        'Tangerine',
        'Teko',
        'Tinos',
        'Ubuntu',
        'Unbounded',
        'Unica One',
        'Vollkorn',
        'Work Sans',
        'Zilla Slab'
    ];

    useEffect(() => {
        const loadSettings = async () => {
            const settingsRecord = await SettingsApi.getSetting('lead-form');
            if (settingsRecord) {
                const settings = settingsRecord.settings;
                setFields(settings.fields);
                setFormTitle(settings.formTitle);
                setColors(settings.colors);
                setInterestedIn(settings.interestedIn);
                setInterestedTitle(settings.interestedTitle);
                setShowInterestedIn(settings.showInterestedIn);
                setFooterText(settings.footerText);
                setMarketingText(settings.marketingText);
                setRedirectUrl(settings.redirectUrl);
                if (settings.font) {
                    setSelectedFont(settings.font);
                }
                formChanged(
                    settings.fields,
                    settings.formTitle,
                    settings.colors,
                    settings.interestedIn,
                    settings.interestedTitle,
                    settings.showInterestedIn,
                    settings.footerText,
                    settings.marketingText,
                    settings.redirectUrl,
                    settings.font
                );
            } else {
                formChanged();
            }
        };

        loadSettings();

        window.addEventListener('message', function(event) {
            if (event.data.type === 'resize') {
                const iframe = document.getElementById('leadForm');
                if (iframe) {
                    iframe.style.height = event.data.height + 'px';
                }
            }
        });
    }, []); // eslint-disable-line

    const handleCheckboxChange = (index, key) => event => {
        const updatedFields = [...fields];
        updatedFields[index][key] = event.target.checked;
        if (key === 'required' && event.target.checked) {
            updatedFields[index]['show'] = event.target.checked;
        }
        setFields(updatedFields);
        formChanged(updatedFields);
    };

    const [dragIndex, setDragIndex] = useState(null);

    const handleDragStart = index => () => {
        setDragIndex(index);
    };

    const handleDragOver = event => {
        event.preventDefault();
    };

    const handleDrop = dropIndex => () => {
        if (dragIndex === null || dragIndex === dropIndex) return;

        const updatedFields = [...fields];
        const [movedItem] = updatedFields.splice(dragIndex, 1);
        updatedFields.splice(dropIndex, 0, movedItem);
        setFields(updatedFields);
        setDragIndex(null);
        formChanged(updatedFields);
    };

    const handleColorChange = key => e => {
        const updatedColors = { ...colors, [key]: e.target.value };
        setColors(updatedColors);
        formChanged(fields, formTitle, updatedColors);
    };

    const formChanged = (
        updatedFields = fields,
        updatedFormTitle = formTitle,
        updatedColors = colors,
        updatedInterested = interestedIn,
        updatedInterestedTitle = interestedTitle,
        updatedShowInterestedIn = showInterestedIn,
        updatedFooterText = footerText,
        updatedMarketingText = marketingText,
        updatedRedirectUrl = redirectUrl,
        updatedFont = selectedFont,
        updatedShowMessageField = showMessageField,
        updatedMessageTitle = messageTitle,
        updatedThankYouText = thankYouText
    ) => {
        let settingsParts = [];
        if (updatedFormTitle) {
            settingsParts.push(`title=${encodeURIComponent(updatedFormTitle)}`);
        }
        settingsParts.push(
            'fields=' +
                updatedFields
                    .filter(field => field.show)
                    .map(field => field.name)
                    .join(',') +
                (updatedShowInterestedIn ? ',interested' : '')
        );

        settingsParts.push(
            'required=' +
                updatedFields
                    .filter(field => field.required)
                    .map(field => field.name)
                    .join(',')
        );

        settingsParts.push('bc=' + updatedColors.background);
        settingsParts.push('tc=' + updatedColors.text);
        settingsParts.push('btnc=' + updatedColors.button);
        settingsParts.push('btntc=' + updatedColors.buttonText);
        settingsParts.push('font=' + encodeURIComponent(updatedFont));

        if (updatedInterested) {
            const sanitizedInterested = updatedInterested.replace(/[\r\n]+/g, ',');
            settingsParts.push('interested=' + encodeURIComponent(sanitizedInterested));
        }

        if (updatedShowInterestedIn && updatedInterestedTitle) {
            settingsParts.push('interestedTitle=' + encodeURIComponent(updatedInterestedTitle));
        }

        if (updatedShowMessageField && updatedMessageTitle) {
            settingsParts.push('messageTitle=' + encodeURIComponent(updatedMessageTitle));
        }

        if (updatedMarketingText) {
            settingsParts.push('marketingText=' + encodeURIComponent(updatedMarketingText));
        }

        if (updatedFooterText) {
            settingsParts.push('footerText=' + encodeURIComponent(updatedFooterText));
        }
        if (updatedThankYouText) {
            settingsParts.push('thankYouText=' + encodeURIComponent(updatedThankYouText));
        }

        if (updatedRedirectUrl) {
            settingsParts.push('redirectUrl=' + encodeURIComponent(updatedRedirectUrl));
        }

        setBase64(btoa(settingsParts.join('&')));
    };

    const handleSave = async () => {
        await SettingsApi.updateSetting('lead-form', {
            formTitle,
            fields,
            colors,
            interestedIn,
            interestedTitle,
            showInterestedIn,
            footerText,
            marketingText,
            redirectUrl,
            font: selectedFont
        });
        toastr.success('Changes saved successfully');
    };

    return (
        <OpenedModal pageContainerStyle={{ width: '90%' }}>
            <Box className={classes.container}>
                <Grid container spacing={4}>
                    <Grid item xs={8}>
                        <Box>
                            <Box display="flex" flexDirection="column" className={classes.box}>
                                <Box display="flex" alignItems="center">
                                    <label style={{ minWidth: 160 }}>Font:</label>
                                    <Autocomplete
                                        options={fonts}
                                        value={selectedFont}
                                        className={classes.autocomplete}
                                        onChange={(event, newValue) => {
                                            setSelectedFont(newValue);
                                            formChanged(
                                                fields,
                                                formTitle,
                                                colors,
                                                interestedIn,
                                                interestedTitle,
                                                showInterestedIn,
                                                footerText,
                                                marketingText,
                                                redirectUrl,
                                                newValue
                                            );
                                        }}
                                        style={{ marginLeft: 10 }}
                                        renderInput={params => (
                                            <TextField {...params} variant="outlined" style={{ minWidth: 280 }} />
                                        )}
                                    />
                                </Box>
                                {[
                                    { label: 'Background Colour', key: 'background' },
                                    { label: 'Font Colour', key: 'text' },
                                    { label: 'Button Colour', key: 'button' },
                                    { label: 'Button Text Colour', key: 'buttonText' }
                                ].map(({ label, key }) => (
                                    <Box key={key} display="flex" alignItems="center">
                                        <label style={{ minWidth: 160 }}>{label}:</label>
                                        <TextField
                                            type="color"
                                            value={colors[key]}
                                            onChange={handleColorChange(key)}
                                            style={{ width: 60, marginLeft: 8 }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                            <Box display="flex" alignItems="center" className={classes.box}>
                                <Box className={classes.label}>
                                    <label htmlFor="form-title">Form title:</label>
                                </Box>
                                <TextField
                                    id="form-title"
                                    variant="outlined"
                                    value={formTitle}
                                    className={classes.textField}
                                    onChange={e => {
                                        const newTitle = e.target.value;
                                        setFormTitle(newTitle);
                                        formChanged(fields, newTitle);
                                    }}
                                />
                            </Box>

                            <Box className={classes.box}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                style={{ width: 20, paddingRight: 0, marginRight: 0 }}
                                            ></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>
                                                <strong>Show</strong>
                                            </TableCell>
                                            <TableCell>
                                                <strong>Required</strong>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fields.map((field, index) => (
                                            <TableRow
                                                key={field.name}
                                                draggable
                                                onDragStart={handleDragStart(index)}
                                                onDragOver={handleDragOver}
                                                onDrop={handleDrop(index)}
                                                style={{ cursor: 'move' }}
                                            >
                                                <TableCell
                                                    style={{
                                                        width: 20,
                                                        paddingRight: 0,
                                                        marginRight: 0
                                                    }}
                                                >
                                                    <DragIndicatorIcon style={{ cursor: 'grab' }} />
                                                </TableCell>
                                                <TableCell>{field.label}</TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={field.show}
                                                        disabled={field.disabled}
                                                        onChange={handleCheckboxChange(index, 'show')}
                                                        color="primary"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={field.required}
                                                        disabled={field.disabled}
                                                        onChange={handleCheckboxChange(index, 'required')}
                                                        color="primary"
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                            <Box display="flex" alignItems="center" className={classes.box}>
                                <Box className={classes.label}>
                                    <label>Interested in title:</label>
                                </Box>
                                <TextField
                                    id="interested-title"
                                    variant="outlined"
                                    value={interestedTitle}
                                    className={classes.textField}
                                    onChange={e => {
                                        const newTitle = e.target.value;
                                        setInterestedTitle(newTitle);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            newTitle,
                                            showInterestedIn
                                        );
                                    }}
                                    fullWidth
                                />
                                <Box ml={2} display="flex" alignItems="center">
                                    <Checkbox
                                        checked={showInterestedIn}
                                        onChange={e => {
                                            setShowInterestedIn(e.target.checked);
                                            formChanged(
                                                fields,
                                                formTitle,
                                                colors,
                                                interestedIn,
                                                interestedTitle,
                                                e.target.checked
                                            );
                                        }}
                                        color="primary"
                                    />
                                    <span>Show</span>
                                </Box>
                            </Box>
                            <Box className={classes.box} display="flex" flexDirection="column">
                                <label>Treatments interested in list:</label>
                                <TextareaAutosize
                                    id="interested"
                                    name="interested"
                                    disabled={!showInterestedIn}
                                    multiline
                                    minRows={3}
                                    variant="outlined"
                                    className={classes.textArea}
                                    value={interestedIn}
                                    onChange={e => {
                                        const newText = e.target.value;
                                        setInterestedIn(newText);
                                        formChanged(fields, formTitle, colors, newText);
                                    }}
                                    fullWidth
                                />
                            </Box>
                            <Box display="flex" alignItems="center" className={classes.box}>
                                <Box className={classes.label}>
                                    <label>Message title:</label>
                                </Box>
                                <TextField
                                    id="message-title"
                                    variant="outlined"
                                    value={messageTitle}
                                    className={classes.textField}
                                    onChange={e => {
                                        const newTitle = e.target.value;
                                        setMessageTitle(newTitle);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            interestedTitle,
                                            showInterestedIn,
                                            footerText,
                                            marketingText,
                                            redirectUrl,
                                            selectedFont,
                                            showMessageField,
                                            newTitle
                                        );
                                    }}
                                    fullWidth
                                />
                                <Box ml={2} display="flex" alignItems="center">
                                    <Checkbox
                                        checked={showMessageField}
                                        onChange={e => {
                                            setShowMessageField(e.target.checked);
                                            formChanged(
                                                fields,
                                                formTitle,
                                                colors,
                                                interestedIn,
                                                interestedTitle,
                                                showInterestedIn,
                                                footerText,
                                                marketingText,
                                                redirectUrl,
                                                selectedFont,
                                                e.target.checked
                                            );
                                        }}
                                        style={{ paddingTop: 2 }}
                                        color="primary"
                                    />
                                    <span style={{ fontSize: 18 }}>Allow message field</span>
                                </Box>
                            </Box>
                            <Box display="flex" className={classes.box} flexDirection="column">
                                <Box className={classes.label}>
                                    <label htmlFor="form-title">Marketing preferences text:</label>
                                </Box>
                                <TextField
                                    id="form-marketingText"
                                    variant="outlined"
                                    value={marketingText}
                                    className={classes.textFieldWide}
                                    onChange={e => {
                                        const newText = e.target.value;
                                        setMarketingText(newText);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            interestedTitle,
                                            showInterestedIn,
                                            footerText,
                                            newText
                                        );
                                    }}
                                />
                            </Box>
                            <Box className={classes.box}>
                                <label>Footer text:</label>
                                <TinyMce
                                    value={footerText || ''}
                                    onChange={content => {
                                        setFooterText(content);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            interestedTitle,
                                            showInterestedIn,
                                            content
                                        );
                                    }}
                                    ref={editorRef}
                                    init={{
                                        height: 150,
                                        plugins: ['lists', 'code', 'link'],
                                        toolbar:
                                            'bold italic strikethrough forecolor backcolor | bullist numlist | link',
                                        menubar: false,
                                        branding: false
                                    }}
                                />
                            </Box>
                            <Box className={classes.box}>
                                <label>Thank you page text:</label>
                                <TinyMce
                                    value={thankYouText || ''}
                                    onChange={content => {
                                        setThankYouText(content);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            interestedTitle,
                                            showInterestedIn,
                                            footerText,
                                            marketingText,
                                            redirectUrl,
                                            selectedFont,
                                            showMessageField,
                                            messageTitle,
                                            content
                                        );
                                    }}
                                    ref={editorRef}
                                    init={{
                                        height: 150,
                                        plugins: ['lists', 'code', 'link'],
                                        toolbar:
                                            'bold italic strikethrough forecolor backcolor | bullist numlist | link',
                                        menubar: false,
                                        branding: false
                                    }}
                                />
                            </Box>
                            <Box display="flex" flexDirection="column" className={classes.box}>
                                <label>Thank you page redirect</label>
                                <Typography>
                                    Redirect your customer to a unique thank you page on completion of a lead form
                                    submission. This is instead of seeing the Collums&apos; thank you page. Don’t forget
                                    to include https:// at the start or your url.
                                </Typography>
                                <TextField
                                    variant="outlined"
                                    value={redirectUrl}
                                    className={classes.textFieldWide}
                                    onChange={e => {
                                        const newText = e.target.value;
                                        setRedirectUrl(newText);
                                        formChanged(
                                            fields,
                                            formTitle,
                                            colors,
                                            interestedIn,
                                            interestedTitle,
                                            showInterestedIn,
                                            footerText,
                                            marketingText,
                                            newText
                                        );
                                    }}
                                />
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item xs={4}>
                        <Box className={classes.box} display="flex" flexDirection="column">
                            <label>How your form will look</label>
                            <iframe
                                title="Lead Preview"
                                id="leadForm"
                                style={{ width: '100%', border: '0px solid ' + colors.text, borderRadius: 4 }}
                                src={`${
                                    JSON.parse(localStorage.getItem('linkCache')).customerAppUrl
                                }/lead?form=${base64}&setup=1`}
                            ></iframe>
                        </Box>
                        <Box className={classes.box} display="flex" flexDirection="column">
                            <label>Form code</label>
                            <Typography>
                                Copy and paste this code into your website - you may need your website developer to help
                                you.
                                <br />
                                Read the article{' '}
                                <a
                                    href="https://support.collums.co/en/articles/11133500-lead-form-builder"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    here
                                </a>{' '}
                                for more information.
                            </Typography>
                            <TextareaAutosize
                                multiline
                                minRows={10}
                                variant="outlined"
                                value={`<iframe id="leadForm" width="500px" style="border-radius: 4px; border: 0px solid ${
                                    colors.text
                                }" src="${
                                    JSON.parse(localStorage.getItem('linkCache')).customerAppUrl
                                }/lead?form=${base64}"></iframe>\n
<script>
    window.addEventListener('message', function (event) {
        if (event.data.type === 'resize') {
            const iframe = document.getElementById('leadForm');
            if (iframe) {
                iframe.style.height = event.data.height + 'px';
            }
        }
        if (typeof event.data === 'string' && event.data.startsWith('redirect:')) {
            window.location.href = event.data.replace('redirect:', '');
        }
    });
</script>`}
                                fullWidth
                                className={classes.textAreaForCode}
                            />
                            <Typography> </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Button className={globalStyles.confirmButton} style={{ margin: 0 }} onClick={handleSave}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </OpenedModal>
    );
}
